import { z } from 'zod';

const ModelSchema = z.object({
  modelId: z.string().uuid('Model name is required'),
  sizeId: z.string().uuid('Size is required'),
  position: z.string().min(1, 'Position is required'),
  quantity: z
    .string()
    .min(1, { message: 'Quantity is required' })
    .transform((val, ctx) => {
      const num = Number(val);
      if (isNaN(num)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Quality must be a number',
        });
        return z.NEVER;
      }
      return num;
    })
    .refine((val) => val >= 0 && val <= 1000, {
      message: 'Quantity must be 0–1000',
    }),
});

const PrinterSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  printerId: z.string().min(1, 'Printer is required'),
  type: z.string().min(1, 'Type is required'),
});

const StyleSchema = z.object({
  styleId: z.string().uuid('Style is required'),
});

const OverlaySchema = z.object({
  overlayId: z.string().uuid('Overlay is required'),
});

const MaskSchema = z.object({
  maskId: z.string().uuid('Mask is required'),
  overlays: z.array(OverlaySchema).optional(),
});

export const EventFormSchema = z.object({
  name: z
    .string()
    .min(3, 'Event name must be at least 3 characters long')
    .regex(/^[a-zA-Z0-9 ]+$/, {
      message: 'Only letters and numbers are allowed',
    })
    .max(100, 'Event name cannot exceed 100 characters'),
  startDate: z.string().refine((val) => !isNaN(Date.parse(val)), {
    message: 'Start date is required',
  }),
  idleStateVideoPublicUrl: z.string().optional(),
  publicUrl: z.string().min(1, 'Video preview is required'),
  aiModel: z.string().min(1, 'AI model is required'),
  printers: z.array(PrinterSchema).min(1, 'At least one printer is required'),
  models: z.array(ModelSchema),
  styles: z.array(StyleSchema),
  masks: z.array(MaskSchema),
});
